import { Component, Inject, OnInit, PLATFORM_ID  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';
import { License } from '../license';
import { Meta, Title } from "@angular/platform-browser";
import { Enum } from '../enum';
import { CanonicalService } from '../../shared/canonical.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'pm-license-detail',
    templateUrl: './license-detail.component.html',
    styleUrls: ['./license-detail.component.css'],
    standalone: false
})
export class LicenseDetailComponent implements OnInit {
  license: License;
  licList: number[];
  licListPtr: number;
  //errorMessage: any;
  enums: Enum[];
  enumFields=[
    {name: 'edu', col: 'education', label: 'Education:'},
    {name: 'cert', col: 'certification', label: 'Certification:'},
    {name: 'cedu', col: 'continuingedu', label: 'Continuing education:'},
    {name: 'exp', col: 'experience', label: 'Experience:'},
    {name: 'exam', col: 'exam', label: 'Exam:'},
    {name: 'crim', col: 'criminal', label: 'Criminal:'},
    {name: 'phy', col: 'physical', label: 'Physical requirements:'},
    {name: 'vet', col: 'veteran', label: 'Veteran:'},
    {name: 'active', col: 'inactive', label: 'Active status:'},
    {name: 'types', col: 'licenseType', label: 'License Type:'},
   ];
  
  // https://stackoverflow.com/questions/54889941/how-to-use-math-min-or-math-max-syntax-in-angular-template
  get math() {
    return Math;
  }
  constructor(private dataService: DataService, private route: ActivatedRoute, private meta: Meta,
      private title: Title, private canonicalService: CanonicalService, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
    this.canonicalService.setCanonicalURL();    
    this.route.params.subscribe(
      params => {
          const id = +params['id'];
          this.getLicense(id);
      }
    );      
    
    if (isPlatformBrowser(this.platformId)){
      let list=sessionStorage.getItem('liclist');
      if (list){      
        this.licList=JSON.parse(list);
      }
    }
    this.dataService.getEnum().subscribe((data: Enum[])=>{
      this.enums=data;
    });
  }

  getLicense(id){
     this.dataService.getLicense(id).subscribe((data: License)=>{
      this.license = data;
     if (this.license.authURL.indexOf("//")<0)
        this.license.authURL="http://"+this.license.authURL;
      if (this.license.appURL.indexOf("//")<0)
        this.license.appURL="http://"+this.license.appURL;
 //     console.log(this.license.licenseURL.indexOf("//"));
      if (this.license.licenseURL.indexOf("//")<0)
        this.license.licenseURL="http://"+this.license.licenseURL;
//      console.log(this.license); 
      if (this.licList)
        this.licListPtr=this.licList.findIndex(x=>x===id);
      this.meta.updateTag({name: "description", content: this.license.licDesc});        
      //this.meta.updateTag({name: "keywords", content: !!this.license.keywords?`"${this.license.keywords.toLowerCase().replace('~','", "',)}"`:' '});
      let desc=this.license.licDesc;   
      this.meta.updateTag({name: "description", content: desc});
      this.title.setTitle(`Licensing for ${this.license.licTitle} in North Carolina`);  
    }) 
  }

  getEnums(){
    return this.enumFields.filter(e=>!!this.license[e.col]); 
  }  

  getEnumVal(name: string, key: string){
    if (this.enums instanceof Array)
      return this.enums.find(f=>f.name==name && f.key==key).value;
    return null;
  }
}
